var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCssIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#38b2ac",
    points: "91.809,117.07 122.593,450.579 255.999,486.501      389.402,450.579 420.191,117.07    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#38b2ac",
    points: "255.997,144.084 255.997,457.852 256.298,457.933      364.257,428.863 389.175,144.084    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E8E8E7",
    points: "255.623,372.537 255.551,372.558 210.981,361.197      208.28,328.479 166.861,328.479 172.263,391.644 256.001,416.637 256.001,372.43    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FBFBFA",
    points: "256.001,266.782 256.001,306.911 256.12,306.911      305.622,306.965 302.445,359.419 256.12,372.47 256.001,372.504 256.001,416.591 256.12,416.627 256.153,416.637      340.114,392.114 351.007,266.782    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E5E4E2",
    points: "161.002,266.782 164.154,306.869 164.159,306.931      256.001,306.937 256.001,266.782    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EEEEEE",
    points: "161.008,266.782 255.768,266.782 256.001,266.681      256.001,226.617    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "261.553,224.667 256.001,226.992 256.001,266.773      353.955,224.667    "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E7E7E6",
    points: "152.196,184.515 157.16,224.667 256.001,224.667      256.001,184.515    "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F8F8F7",
    d: "m256.001,224.667l101.842,-40.152l-101.842,0l0,40.152zm0.027,0l97.76,0l4.056,-40.152l-101.816,40.152z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#38b2ac",
    d: "m158.564,87.892l50.683,0l0,-19.822l-28.961,0l0,-19.85l28.961,0l0,-21.721l-50.683,0l0,61.393zm72.343,-39.671c6.781,6.781 10.317,10.026 20.125,19.835c-5.732,0 -20.125,0.021 -20.125,0.019l0,19.817l50.687,0l0,-19.822l-20.246,-19.85l20.246,0l0,-21.721l-50.687,0c0,0 0,10.902 0,21.722zm122.529,-21.722l-50.69,0c0,0 0,10.902 0,21.722c6.781,6.781 10.319,10.026 20.127,19.835c-5.73,0 -20.127,0.021 -20.127,0.019l0,19.817l50.69,0l0,-19.822l-20.247,-19.85l20.247,0l0,-21.721z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/cssIcon.522c4f162217aa9af9fdc0d0d6f8c207.svg";
export { ForwardRef as ReactComponent };